import React from 'react';
import {
  KeyboardAvoidingView,
  KeyboardAvoidingViewProps,
  ScrollView,
  ScrollViewProps,
  StyleSheet,
  View,
  ViewProps,
} from 'react-native';

import {useAdaptiveSafeArea} from '../../../lib/hooks/useAdaptiveSafeArea';
import {useBreakpoints} from '../../../lib/hooks/useBreakpoints';
import {screenColorScheme} from '../../screenColorScheme';

const {backgroundColor} = screenColorScheme;

export const Scroller: React.FC<ScrollViewProps> = ({style, ...props}) => (
  <ScrollView
    showsVerticalScrollIndicator={false}
    style={[styles.scroller, style]}
    {...props}
  />
);

export const ConditionalScroller: React.FC<ScrollViewProps> = ({
  style,
  ...props
}) => {
  const {isMedium} = useBreakpoints();

  if (!isMedium) return <View style={[styles.scroller, style]} {...props} />;

  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      style={[styles.scroller, style]}
      {...props}
    />
  );
};
export const Layout: React.FC<ViewProps> = ({style, ...props}) => {
  const {bottom} = useAdaptiveSafeArea();

  return (
    <View
      style={[styles.layout, {paddingBottom: 24 + bottom}, style]}
      {...props}
    />
  );
};

export const KeyboardAvoidingLayout: React.FC<KeyboardAvoidingViewProps> = ({
  style,
  ...props
}) => {
  const {bottom} = useAdaptiveSafeArea();

  return (
    <KeyboardAvoidingView
      style={[styles.layout, {paddingBottom: bottom}, style]}
      {...props}
    />
  );
};

const styles = StyleSheet.create({
  layout: {
    flex: 1,
    backgroundColor,
    flexBasis: 0,
  },
  scroller: {
    flex: 1,
  },
});
